export default __webpack_public_path__ + "static/media/bg-list-2.247eb4c8.svg";